export enum WarrantiesTypeEnum {
  GC = "GC",
  GE = "GE",
  GL = "GL",
  GPR = "GPR",
}
